import { createRouter } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { indexRoute } from "@/routes/home";
import { parentsRoute } from "@/routes/parents";
import { instrumentRoute } from "@/routes/instrument.$instrumentId";
import { songsRoute } from "@/routes/songs";
import { songRoute } from "@/routes/songs.$songId";
import { simonRoute } from "@/routes/games.simon";
import { whoSoundsRoute } from "@/routes/games.who-sounds";
import { countAndPlayRoute } from "@/routes/games.count-and-play";
import { duoRoute } from "@/routes/games.duo";
import { pluginRoutes } from "@/composition";
import { collectionRoute } from "@/routes/collection";
import { progressRoute } from "@/routes/progress";
import { NotFoundRoute } from "@/components/not-found-route";
import { isDuoEnabled } from "@/lib/p2p/signaling-availability";

/**
 * Routes for disabled features. Duo is RETIRED from the product (2026-08-03) on all
 * platforms: with the switch off its route does not enter the tree, so `/games/duo`
 * falls into "page not found" instead of half-existing. See
 * `docs/P2P_SIGNALING_ENABLEMENT.md` and `lib/p2p/signaling-availability.ts`.
 *
 * It is evaluated here, when building the tree, and not inside the route, because a registered route
 * is already surface: it appears in the navigation types and `defaultPreload: "intent"` would
 * preload it. `beforeLoad` in `games.duo.tsx` is the belt, this is the suspenders.
 */
const featureRoutes = isDuoEnabled() ? [duoRoute] : [];

const routeTree = rootRoute.addChildren([
  indexRoute,
  ...pluginRoutes,
  parentsRoute,
  instrumentRoute,
  songsRoute,
  songRoute,
  simonRoute,
  whoSoundsRoute,
  countAndPlayRoute,
  ...featureRoutes,
  collectionRoute,
  progressRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // Unknown URL → playful "page not found" state with a CTA to home,
  // instead of a blank screen.
  defaultNotFoundComponent: NotFoundRoute,
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
